import svg from './row-svg/dashboard.svg';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function DashbaordIcon(props: FixMe) {
  return <img {...props} src={svg} alt="svg" />;
}

export default DashbaordIcon;
